import { Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Overlay di caricamento che copre il container `position: relative` in cui è inserito.
 */
@Component({
  selector: 'app-local-loader',
  standalone: true,
  imports: [MatProgressSpinnerModule, TranslateModule],
  templateUrl: './local-loader.component.html'
})
export class LocalLoaderComponent {
  @Input() loading: boolean = false;
  @Input() message?: string | null;
}
